module.exports = __webpack_public_path__ + "img/09.86827448.jpg";